import { PowerPledgeEntry } from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/+state/presenter-widgets.models'

export const PRESENTER_POWER_PLEDGE_TEST_DONOR_TOTALS: PowerPledgeEntry[] = [
  { uuid: '001', name: 'Alex Morgan', total: 12500 },
  { uuid: '002', name: 'Taylor Singh', total: 10200 },
  { uuid: '003', name: 'Anonymous', total: 9850 },
  { uuid: '004', name: 'Jordan Chen', total: 8100 },
  { uuid: '005', name: 'Sam Patel', total: 7600 },
  { uuid: '006', name: 'Riley Brooks', total: 6250 },
  { uuid: '007', name: 'Casey Nguyen', total: 5900 },
  { uuid: '008', name: 'Jamie Lewis', total: 4150 },
  { uuid: '009', name: 'Avery Johnson', total: 3800 },
  { uuid: '010', name: 'Charlie Williams', total: 2500 },
]
